(function() {
    'use strict';

    angular.module('doclr.components.loading', [])
        .factory('loadingInterceptor', function($q, $injector, $rootScope) {
            let loadingState = {
                loading:false
            };

            $rootScope.doclrLoadingState = loadingState;

            return {
                request : function(config) {
                    if($injector.get('$http').pendingRequests.length === 0) {
                        loadingState.loading=true;
                        $injector.get('$rootScope').$broadcast('start_loading_data');
                    }
                    return config || $q.when(config);
                },
                requestError : function(rejection) {
                    if($injector.get('$http').pendingRequests.length === 0) {
                        loadingState.loading=false;
                        $injector.get('$rootScope').$broadcast('stop_loading_data');
                    }
                    $q.reject(rejection);
                },
                response : function(response) {
                    if($injector.get('$http').pendingRequests.length === 0) {
                        loadingState.loading=false;
                        $injector.get('$rootScope').$broadcast('stop_loading_data');
                    }
                    return response || $q.when(response);
                },
                responseError : function(rejection) {
                    if($injector.get('$http').pendingRequests.length === 0) {
                        loadingState.loading=false;
                        $injector.get('$rootScope').$broadcast('stop_loading_data');
                    }
                    return $q.reject(rejection);
                }
            };
        })
        .config(function($httpProvider) {
            $httpProvider.interceptors.push('loadingInterceptor');
        })
        .directive('showWhenLoading', function() {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    element.hide();

                    scope.$on('start_loading_data', function () {
                        element.show();
                    });

                    scope.$on('stop_loading_data', function () {
                        element.hide();
                    });
                }
            };
        });
})();
